import React, { useEffect } from "react";
import { Item } from "../../../../store/viewmodels/ItemViewModel";
import { shuffleItems } from "../../../../utils/ItemServices";
import OrganizeCard from "./OrganizeCard";

export interface OrganizeCardsProps {
    item: Item,
    clear: boolean,
    setClear: React.Dispatch<React.SetStateAction<boolean>>,
    isInstruction: boolean,
    setOrderedItems: React.Dispatch<React.SetStateAction<any[]>>,
}

const emptyItem: Item = {
    id: -1,
    name: "",
    type: "",
    settings: {},
    files: [],
    content: "",
    child_items: [],
    correct: "",
    index: NaN
}

function OrganizeCards(props: OrganizeCardsProps): JSX.Element {
    const [selectedCards, setSelectedCards] = React.useState([] as { row: string, index: number }[]);
    const [firstRow, setFirstRow] = React.useState([] as any[]);
    const [secondRow, setSecondRow] = React.useState([] as any[]);
    const [updated, setUpdated] = React.useState(false);
    let itemCount: number = props.item.child_items.length;

    useEffect(() => {
        start(props.item, setFirstRow, setSecondRow);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.item]);

    useEffect(() => {
        if (props.clear === true) {
            start(props.item, setFirstRow, setSecondRow);
            props.setClear(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.clear]);

    useEffect(() => {
        if (selectedCards.length >= 2) {
            if (selectedCards[0].row === selectedCards[1].row) {
                let row = selectedCards[0].row;
                let rowArray = selectedCards[0].row === "firstRow" ? Array.from(firstRow) : Array.from(secondRow);
                let help = rowArray[selectedCards[0].index];

                rowArray[selectedCards[0].index] = rowArray[selectedCards[1].index];
                rowArray[selectedCards[1].index] = help;

                switch (row) {
                    case "firstRow": {
                        setFirstRow(rowArray);
                        clearAll(setSelectedCards, updated, setUpdated);
                        break;
                    }
                    case "secondRow": {
                        setSecondRow(rowArray);
                        clearAll(setSelectedCards, updated, setUpdated);
                        break;
                    }
                    default: break;
                }

            } else {
                switch (selectedCards[0].row) {
                    case "firstRow": {
                        switchPlaces(firstRow, setFirstRow, secondRow, setSecondRow, selectedCards[0].index, selectedCards[1].index);
                        clearAll(setSelectedCards, updated, setUpdated);

                        break;
                    }
                    case "secondRow": {
                        switchPlaces(firstRow, setFirstRow, secondRow, setSecondRow, selectedCards[1].index, selectedCards[0].index);
                        clearAll(setSelectedCards, updated, setUpdated);
                        break;
                    }
                    default: break;
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCards]);

    useEffect(() => {
        let answers = [] as any[];
        for (let i: number = 0; i < secondRow.length; i++) {
            if (secondRow[i].item.id !== -1) {
                answers.push(secondRow[i].item);
            }
            props.setOrderedItems(answers);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secondRow])

    const gridColsCount = "grid-cols-" + itemCount
    
    let firstRowCards = firstRow.map((card, index) => (
        <OrganizeCard
            key={"firstCard_" + card.item.id + "_" + index}
            index={index}
            place={"firstRow"}
            file={card.file}
            item={card.item.id}
            setSelectedCards={setSelectedCards}
            selectedCards={selectedCards}
            updated={updated}
        />
    ));

    let secondRowCards = secondRow.map((card, index) => (
        <OrganizeCard
            key={"secondCard_" + card.item.id + "_" + index}
            index={index}
            place={"secondRow"}
            file={card.file}
            item={card.item.id}
            setSelectedCards={setSelectedCards}
            selectedCards={selectedCards}
            updated={updated}
        />
    ));

    return (
        <div className={"mx-auto justify-center max-w-full"}>
            <div className="grid grid-rows-2">
                <div className={"grid " + gridColsCount + ""}>{firstRowCards}</div>
                <div className={"grid " + gridColsCount + " md:mt-2"}>{secondRowCards}</div>
            </div>
        </div>);
}

function clearAll(setSelectedCards: React.Dispatch<React.SetStateAction<any[]>>, updated: boolean, setUpdated: React.Dispatch<React.SetStateAction<boolean>>) {
    setSelectedCards([] as { row: string, index: number }[]);
    setUpdated(!updated);
}

function switchPlaces(firstRow: any[], setFirstRow: React.Dispatch<React.SetStateAction<any[]>>, secondRow: any[], setSecondRow: React.Dispatch<React.SetStateAction<any[]>>, index_a: number, index_b: number) {
    let row1 = Array.from(firstRow);
    let row2 = Array.from(secondRow);
    let help = row1[index_a];
    row1[index_a] = row2[index_b];
    row2[index_b] = help;

    setFirstRow(row1);
    setSecondRow(row2);
}

function start(item: Item, setFirstRow: React.Dispatch<React.SetStateAction<any[]>>, setSecondRow: React.Dispatch<React.SetStateAction<any[]>>) {

    let shuffled = shuffleItems(item.child_items);

    let firstRowCards: any[] = [];
    let emptyCards: any[] = [];

    shuffled.forEach(i => {
        const firstCard = {
            item: i,
            file: i.files[0]
        }

        const emptyCard = {
            item: emptyItem,
            file: undefined
        }

        firstRowCards.push(firstCard);
        emptyCards.push(emptyCard);
    });

    setFirstRow(firstRowCards);
    setSecondRow(emptyCards);
}


export default OrganizeCards;